import { forwardRef } from 'react';

import { getCurrencySymbol } from 'components/Fields/helpers';
import PriceNumberInline from 'components/Inputs/inline/TextInput/presets/PriceNumber';

import { withCellWrapper } from '../helpers';

import { getDataQAForInput } from 'components/Inputs/helpers';

const _EntityValueCell = forwardRef(
  (
    {
      field,
      entityId,
      onSubmit,
      value,
      objectId: modelId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      editable,
      onAutoFocus,
      meta,
      ...others
    },
    ref
  ) => {
    return (
      <PriceNumberInline
        ref={ref}
        {...others}
        field={field}
        entityId={entityId}
        value={value}
        onSubmit={async (data) => {
          await onSubmit(data?.entity_value ?? data);
        }}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        currencySymbol={getCurrencySymbol(field)}
        {...getDataQAForInput(
          `inline-record-field-${field.name}`,
          field.fieldType
        )}
      />
    );
  }
);

export const EntityValueCell = withCellWrapper(_EntityValueCell);
